import type { FC } from 'react';

interface Props {}

const CommunityLocationMap: FC<Props> = ({}) => {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.4007182736857!2d-97.74285168488489!3d30.26714998179801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644b509e6cc4ff9%3A0x9e1e9e1c1c1c1c1c!2sAustin%2C%20TX!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      title="BTR Community Location"
    />
  );
};

export default CommunityLocationMap;
